import {LoaderFunctionArgs} from 'react-router-dom';
import {getETicket} from '../../redux/eTicket/eTicketActions';

export const eTicketLoader = async ({params}: LoaderFunctionArgs) => {
    const {token} = params;

    if(!token) {
        throw new Response('Invalid token', {status: 400});
    }

    await getETicket(token);
    return null;
};
